{
  "containerInfoFormConfig": {
    "formRows": [
      {
        "formGroups": [
          {
            "control": {
              "label": "documentNo",
              "displayLabel": "Shipping Bill No",
              "disabled": false,
              "placeHolder": "Enter Shipping Bill No",
              "fieldInfo": {
                "dataType": "text"
              },
              "validators": [
                {
                  "type": "required",
                  "message": "Shipping Bill No. is required"
                }
              ]
            }
          },
          {
            "control": {
              "label": "shippingBillDate",
              "displayLabel": "Shipping Bill Date",
              "placeHolder": "Enter Shipping Bill Date",
              "fieldInfo": {
                "dataType": "datetime-local",
                "defaultToCurrentDate": true
              },
              "validators": [
                {
                  "type": "required",
                  "message": "Shipping Bill Date is required"
                }
              ]
            }
          },
          {
            "control": {
              "label": "freightForwarder",
              "displayLabel": "Freight Forwarder",
              "placeHolder": "Enter Freight Forwarder",
              "returnRawValue": false,
              "fieldInfo": {
                "dataType": "picklist",
                "lookupDetails": {
                  "apiUrl": "v1/customers/list",
                  "filterByKeys": [
                    "NAME_CONTAINS"
                  ],
                  "additionalFilters": [
                    {
                      "name": "IS_ACTIVE",
                      "alias": "active",
                      "value": [
                        "true"
                      ]
                    },
                    {
                      "name": "CUSTOMER_TYPE_CONTAINS",
                      "alias": "customerType",
                      "value": [
                        "FREIGHT_FORWARDER"
                      ]
                    }
                  ],
                  "limit": 10,
                  "orderBy": {
                    "name": "asc"
                  },
                  "bindLabel": "name",
                  "bindValue": "id",
                  "displayColumns": [
                    {
                      "key": "name",
                      "header": "Name"
                    },
                    {
                      "key": "code",
                      "header": "Code"
                    }
                  ]
                }
              },
              "validators": [
                {
                  "type": "required",
                  "message": "Freight Forwarder is required"
                }
              ]
            }
          },
          {
            "control": {
              "label": "cha",
              "displayLabel": "CHA License Holder",
              "placeHolder": "Enter CHA License Holder",
              "returnRawValue": false,
              "fieldInfo": {
                "dataType": "picklist",
                "lookupDetails": {
                  "apiUrl": "v1/customers/list",
                  "filterByKeys": [
                    "NAME_CONTAINS"
                  ],
                  "additionalFilters": [
                    {
                      "name": "IS_ACTIVE",
                      "alias": "active",
                      "value": [
                        "true"
                      ]
                    },
                    {
                      "name": "CUSTOMER_TYPE_CONTAINS",
                      "alias": "customerType",
                      "value": [
                        "CHA"
                      ]
                    }
                  ],
                  "limit": 10,
                  "orderBy": {
                    "name": "asc"
                  },
                  "bindLabel": "name",
                  "bindValue": "id",
                  "displayColumns": [
                    {
                      "key": "name",
                      "header": "Name"
                    },
                    {
                      "key": "code",
                      "header": "Code"
                    }
                  ]
                }
              },
              "validators": [
              ]
            }
          },
          {
            "control": {
              "label": "exporter",
              "displayLabel": "Exporter",
              "placeHolder": "Enter Exporter",
              "returnRawValue": false,
              "fieldInfo": {
                "dataType": "picklist",
                "lookupDetails": {
                  "apiUrl": "v1/customers/list",
                  "filterByKeys": [
                    "NAME_CONTAINS"
                  ],
                  "additionalFilters": [
                    {
                      "name": "IS_ACTIVE",
                      "alias": "active",
                      "value": [
                        "true"
                      ]
                    },
                    {
                      "name": "CUSTOMER_TYPE_CONTAINS",
                      "alias": "customerType",
                      "value": [
                        "EXPORTER"
                      ]
                    }
                  ],
                  "limit": 10,
                  "orderBy": {
                    "name": "asc"
                  },
                  "bindLabel": "name",
                  "bindValue": "id",
                  "displayColumns": [
                    {
                      "key": "name",
                      "header": "Name"
                    },
                    {
                      "key": "code",
                      "header": "Code"
                    }
                  ]
                }
              },
              "validators": [
                {
                  "type": "required",
                  "message": "Exporter is required"
                }
              ]
            }
          },
          {
            "control": {
              "label": "invoiceNo",
              "displayLabel": "Invoice No.",
              "placeHolder": "Enter Invoice No.",
              "fieldInfo": {
                "dataType": "text"
              }
            }
          },
          {
            "control": {
              "label": "invoiceDate",
              "displayLabel": "Invoice Date",
              "placeHolder": "Enter Invoice Date",
              "fieldInfo": {
                "dataType": "datetime-local"
              }
            }
          }
        ]
      }
    ]
  },
  "vesselInfoFormConfig": {
    "formRows": [
      {
        "formGroups": [
          {
            "control": {
              "label": "pol",
              "displayLabel": "Port of Loading",
              "disabled": false,
              "placeHolder": "Enter Shipping Port of Loading",
              "returnRawValue": false,
              "fieldInfo": {
                "dataType": "picklist",
                "lookupDetails": {
                  "apiUrl": "v1/locations/list",
                  "filterByKeys": [
                    "NAME_CONTAINS"
                  ],
                  "additionalFilters": [
                    {
                      "name": "IS_ACTIVE",
                      "alias": "active",
                      "value": [
                        "true"
                      ]
                    },
                    {
                      "name": "LOCATION_TYPE_IN",
                      "alias": "LOCATION_TYPE_IN",
                      "value": ["PORT"]
                    }
                  ],
                  "limit": 10,
                  "orderBy": {
                    "name": "asc"
                  },
                  "bindLabel": "name",
                  "bindValue": "id",
                  "displayColumns": [
                    {
                      "key": "name",
                      "header": "Name"
                    }
                  ]
                }
              },
              "validators": [
                {
                  "type": "required",
                  "message": "Port of Loading is required"
                }
              ]
            }
          },
          {
            "control": {
              "label": "pod",
              "displayLabel": "Port of Destination",
              "disabled": false,
              "placeHolder": "Enter Port of Destination",
              "returnRawValue": false,
              "fieldInfo": {
                "dataType": "picklist",
                "lookupDetails": {
                  "apiUrl": "v1/locations/list",
                  "filterByKeys": [
                    "NAME_CONTAINS"
                  ],
                  "additionalFilters": [
                    {
                      "name": "IS_ACTIVE",
                      "alias": "active",
                      "value": [
                        "true"
                      ]
                    },
                    {
                      "name": "LOCATION_TYPE_IN",
                      "alias": "LOCATION_TYPE_IN",
                      "value": ["PORT"]
                    }
                  ],
                  "limit": 10,
                  "orderBy": {
                    "name": "asc"
                  },
                  "bindLabel": "name",
                  "bindValue": "id",
                  "displayColumns": [
                    {
                      "key": "name",
                      "header": "Name"
                    }
                  ]
                }
              },
              "validators": [
              ]
            }
          },
          {
            "control": {
              "label": "finalPod",
              "displayLabel": "Final Port of Destination",
              "disabled": false,
              "placeHolder": "Enter Final Port of Destination",
              "returnRawValue": false,
              "fieldInfo": {
                "dataType": "picklist",
                "lookupDetails": {
                  "apiUrl": "v1/locations/list",
                  "filterByKeys": [
                    "NAME_CONTAINS"
                  ],
                  "additionalFilters": [
                    {
                      "name": "IS_ACTIVE",
                      "alias": "active",
                      "value": [
                        "true"
                      ]
                    },
                    {
                      "name": "LOCATION_TYPE_IN",
                      "alias": "LOCATION_TYPE_IN",
                      "value": ["PORT"]
                    }
                  ],
                  "limit": 10,
                  "orderBy": {
                    "name": "asc"
                  },
                  "bindLabel": "name",
                  "bindValue": "id",
                  "displayColumns": [
                    {
                      "key": "name",
                      "header": "Name"
                    }
                  ]
                }
              },
              "validators": [
              ]
            }
          }
        ]
      }
    ]
  },
  "cargoInfoFormConfig": {
    "formRows": [
      {
        "formGroups": [
          {
            "control": {
              "label": "commodity",
              "displayLabel": "Commodity",
              "disabled": false,
              "placeHolder": "Enter Commodity",
              "returnRawValue": false,
              "fieldInfo": {
                "dataType": "picklist",
                "lookupDetails": {
                  "apiUrl": "v1/commodities/list",
                  "filterByKeys": [
                    "NAME_CONTAINS"
                  ],
                  "additionalFilters": [
                    {
                      "name": "IS_ACTIVE",
                      "alias": "active",
                      "value": [
                        "true"
                      ]
                    }
                  ],
                  "limit": 10,
                  "orderBy": {
                    "name": "asc"
                  },
                  "bindLabel": "name",
                  "bindValue": "id",
                  "displayColumns": [
                    {
                      "key": "name",
                      "header": "Name"
                    }
                  ]
                }
              },
              "validators": [
                {
                  "type": "required",
                  "message": "Commodity is required"
                }
              ]
            }
          },
          {
            "control": {
              "label": "packageType",
              "displayLabel": "Package Type",
              "disabled": false,
              "placeHolder": "Enter Package Type",
              "returnRawValue": false,
              "fieldInfo": {
                "dataType": "picklist",
                "lookupDetails": {
                  "apiUrl": "v1/packages/list",
                  "filterByKeys": [
                    "NAME_CONTAINS"
                  ],
                  "additionalFilters": [
                    {
                      "name": "IS_ACTIVE",
                      "alias": "active",
                      "value": [
                        "true"
                      ]
                    }
                  ],
                  "limit": 10,
                  "orderBy": {
                    "name": "asc"
                  },
                  "bindLabel": "name",
                  "bindValue": "id",
                  "displayColumns": [
                    {
                      "key": "name",
                      "header": "Name"
                    }
                  ]
                }
              },
              "validators": [
              ]
            }
          },
          {
            "control": {
              "label": "nop",
              "displayLabel": "No. of Packages",
              "disabled": false,
              "placeHolder": "Enter No. of Packages",
              "fieldInfo": {
                "dataType": "number"
              },
              "validators": [
                {
                  "type": "required",
                  "message": "No. of Packages is required"
                }
              ]
            }
          },
          {
            "control": {
              "label": "weight",
              "displayLabel": "Gross Weight (in KG)",
              "disabled": false,
              "placeHolder": "Enter Gross Weight (in KG)",
              "fieldInfo": {
                "dataType": "number"
              },
              "validators": [
              ]
            }
          },
          {
            "control": {
              "label": "fobValue",
              "displayLabel": "FOB Value (in Rs.)",
              "disabled": false,
              "placeHolder": "Enter FOB Value (in Rs.)",
              "fieldInfo": {
                "dataType": "number"
              },
              "validators": [
              ]
            }
          },
          {
            "control": {
              "label": "coldStorage",
              "displayLabel": "Cold Storage",
              "disabled": false,
              "defaultValue": false,
              "placeHolder": "Cold Storage",
              "fieldInfo": {
                "dataType": "boolean"
              }
            }
          },
          {
            "control": {
              "label": "temperature",
              "displayLabel": "Set Temperature",
              "disabled": false,
              "placeHolder": "Enter Set Temperature",
              "fieldInfo": {
                "dataType": "number"
              },
              "conditions": {
                "disabled": {
                  "logic": "AND",
                  "rules": [
                    {
                      "field": "coldStorage",
                      "operator": "EQUALS",
                      "value": false
                    }
                  ]
                }
              },
              "validators": [
                {
                  "type": "required",
                  "message": "Set Temperature is required"
                }
              ]
            }
          }
        ]
      },
      {
        "formGroups": [
          {
            "control": {
              "label": "hazardous",
              "displayLabel": "Hazardous",
              "disabled": false,
              "defaultValue": false,
              "placeHolder": "Hazardous",
              "fieldInfo": {
                "dataType": "boolean"
              }
            }
          },
          {
            "control": {
              "label": "unNo",
              "displayLabel": "UN No.",
              "disabled": false,
              "placeHolder": "Enter UN No.",
              "fieldInfo": {
                "dataType": "text"
              },
              "conditions": {
                "disabled": {
                  "logic": "AND",
                  "rules": [
                    {
                      "field": "hazardous",
                      "operator": "EQUALS",
                      "value": false
                    }
                  ]
                }
              },
              "validators": [
                {
                  "type": "required",
                  "message": "UN No. is required"
                }
              ]
            }
          },
          {
            "control": {
              "label": "imoCode",
              "displayLabel": "IMO Code",
              "disabled": false,
              "placeHolder": "Enter IMO Code",
              "fieldInfo": {
                "dataType": "text"
              },
              "conditions": {
                "disabled": {
                  "logic": "AND",
                  "rules": [
                    {
                      "field": "hazardous",
                      "operator": "EQUALS",
                      "value": false
                    }
                  ]
                }
              },
              "validators": [
                {
                  "type": "required",
                  "message": "IMO Code is required"
                }
              ]
            }
          },
          {
            "control": {
              "label": "sttNo",
              "displayLabel": "STT Number",
              "disabled": false,
              "placeHolder": "Enter STT Number",
              "fieldInfo": {
                "dataType": "text"
              },
              "validators": [
              ]
            }
          },
          {
            "control": {
              "label": "cartingCommunication",
              "displayLabel": "Carting Communication",
              "disabled": false,
              "placeHolder": "",
              "fieldInfo": {
                "dataType": "boolean"
              },
              "validators": [
              ]
            }
          },
          {
            "control": {
              "label": "pcinNo",
              "displayLabel": "PCIN Number",
              "disabled": false,
              "placeHolder": "Enter PCIN Number",
              "fieldInfo": {
                "dataType": "text"
              },
              "validators": [
              ]
            }
          },
          {
            "control": {
              "label": "shippingBillType",
              "displayLabel": "Shipping Bill Type",
              "disabled": false,
              "placeHolder": "Enter Shipping Bill Type",
              "fieldInfo": {
                "dataType": "select",
                "options": [
                  {
                    "value": "DOCK",
                    "label": "Dock"
                  },
                  {
                    "value": "FACTORY",
                    "label": "Factory"
                  }
                ],
                "placeHolder": "Select Shipping Bill Type",
                "displayKey": "label",
                "valueKey": "value"
              },
              "validators": [
              ]
            }
          },
          {
            "control": {
              "label": "stuffingType",
              "displayLabel": "Stuffing Type",
              "disabled": false,
              "placeHolder": "Enter Stuffing Type",
              "fieldInfo": {
                "dataType": "select",
                "options": [
                  {
                    "value": "MANUAL",
                    "label": "Manual"
                  },
                  {
                    "value": "CARGO_WITH_CONTAINER",
                    "label": "Cargo With Container"
                  },
                  {
                    "value": "CROSS_STUFFING",
                    "label": "Cross Stuffing"
                  },
                  {
                    "value": "MECHANICAL",
                    "label": "Mechanical"
                  }
                ],
                "placeHolder": "Select Stuffing Type",
                "displayKey": "label",
                "valueKey": "value"
              },
              "validators": [
              ]
            }
          },
          {
            "style": {
              "gridColumn": "span 6"
            },
            "control": {
              "label": "cargoDescription",
              "displayLabel": "Cargo Description",
              "disabled": false,
              "placeHolder": "Enter Cargo Description",
              "fieldInfo": {
                "dataType": "textarea"
              },
              "validators": [
              ]
            }
          }
        ]
      }
    ]
  }
}


